import {NgModule} from '@angular/core';
import {TransactionListPageModule} from './transaction-list-page/transaction-list-page.module';

@NgModule({
  declarations: [],
  imports: [
    TransactionListPageModule
  ],
  exports: [
    TransactionListPageModule
  ]
})
export class TestModule {
}
